export const GET_COLLECTION_SUCCESS = 'GET_COLLECTION_SUCCESS';
